<template>
    <v-sheet class="w-100 pa-4" border rounded elevation="1" color="background">
        <div
            class="d-flex flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row"
        >
            <!-- Content div -->
            <div class="flex-grow-1">
                <!-- Icono y título de estatus -->

                <div class="d-flex align-center">
                    <v-icon
                        v-if="elementos && elementos.length > 0"
                        :color="elementos[0].color"
                        :icon="elementos[0].icono"
                        size="small"
                        class="me-2"
                    ></v-icon>
                    <p
                        class="text-body-1 font-weight-bold text-uppercase"
                        :class="
                            elementos && elementos.length > 0
                                ? elementos[0].texto_color
                                : ''
                        "
                    >
                        {{ t("decorador.estatus.etiqueta") }}:
                        {{ t("decorador.estatus." + estatus + ".titulo") }}
                    </p>
                </div>
                <!-- comentarios de la revisión -->
                <div v-if="estatus == 2 && comentarios_revision != null">
                    <div
                        class="text-body-1 text-textDark text-justify mt-2 pl-6"
                    >
                        {{ comentarios_revision }}
                    </div>
                </div>
                <!-- Texto fijo de estatus -->
                <div class="text-body-1 text-justify mt-2 pl-6" v-else>
                    <p class="text-textDark">
                        {{ t("decorador.estatus." + estatus + ".texto") }}
                    </p>
                    <p
                        class="text-textLight text-body-2"
                        v-if="editable && stand == standId"
                    >
                        {{ t("decorador.estatus." + estatus + ".nota") }}
                    </p>
                </div>
            </div>
            <!-- botón para regresar a modo de edición -->
            <div
                v-if="editable && stand == standId"
                class="d-flex align-center justify-center flex-shrink-0"
                :class="{
                    'mt-4': true,
                    'mt-sm-0': true,
                    'ms-sm-4': true,
                }"
            >
                <v-btn
                    :color="
                        elementos && elementos.length > 0
                            ? elementos[0].color
                            : 'primary'
                    "
                    variant="outlined"
                    @click="editar"
                >
                    {{ t("boton-editar") }}
                </v-btn>
            </div>
        </div>
    </v-sheet>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import { computed } from "vue";
import axios from "axios";

const { t } = useI18n();

const props = defineProps({
    item: Object, // objeto completo (decorador_solicitud)
    stand: Number, // identificador del stand
    historial_revision: Object,
});

// Computed properties para extraer valores de item si se proporciona
const standId = computed(() => {
    if (props.item) {
        // Intentar obtener stand_id de diferentes formas
        if (props.item.stand_id) return props.item.stand_id;
        if (props.item.stand?.id) return props.item.stand.id;
        if (props.item.stand_id) return props.item.stand_id;
    }
    return props.stand;
});

const itemId = computed(() => {
    if (props.item) {
        return props.item.id;
    }
    return props.id;
});

// Función helper para obtener icono según estatus
const getIconoByEstatus = (estatus) => {
    const iconos = {
        2: "mdi-alert-circle", // requiere acción
        3: "mdi-information", // corregida - en revisión
        4: "mdi-information", // en revisión
        5: "mdi-check-circle", // aceptado
    };
    return iconos[estatus] || "mdi-information";
};

const estatus = computed(() => {
    if (props.item != null) {
        return props.item.estatus;
    }
    return props.estatus;
});

const comentarios_revision = computed(() => {
    if (props.item != null) {
        return props.item.comentarios_revision;
    }
    return null;
});

const elementos = computed(() => {
    if (props.item && props.item.estatus_elementos) {
        return props.item.estatus_elementos;
    }
    return [];
});

const editable = computed(() => {
    if (props.item != null) {
        return props.item.editable;
    }
    return props.editable;
});

const emit = defineEmits(["editado"]);

const editar = () => {
    axios
        .post(
            route("decorador-solicitudes.estatus", {
                stand: standId.value,
                decorador_solicitud: itemId.value,
            })
        )
        .then(() => {
            emit("editado");
        });
};
</script>
